<script setup>
import AffiliateLayout from "./layouts/AffiliateLayout.vue";
import ReferAFriendLayout from "../referral-portal/auth/layouts/ReferAFriendLayout.vue";
import NewsletterLayout from "./layouts/NewsletterLayout.vue";
import {computed, onMounted} from "vue";
import {usePortalContentAndDesignStore} from "../../../stores/partners/portalContentAndDesignStore";

const props = defineProps({
    programType: {
        type: String,
        default: null,
    },
    portal_settings: {
        type: Object,
        default: () => ({}),
    },
})

const portalContentAndDesignStore = usePortalContentAndDesignStore();

onMounted(() => {
    // Initialize portal content for auth view
    if (props.portal_settings && Object.keys(props.portal_settings).length > 0) {
        portalContentAndDesignStore.initializePortalContent(props.portal_settings, true, false);
    }
});

const layoutComponent = computed(() => {
    switch (props.programType) {
        case 'affiliate':
            return AffiliateLayout
        case 'refer-a-friend':
            return ReferAFriendLayout
        case 'newsletter':
            return NewsletterLayout
        default:
            return AffiliateLayout
    }
})
</script>
<template>
    <component v-if="programType" :is="layoutComponent">
        <router-view />
    </component>
</template>
